import { AU1_BUGFIX_HOSTS } from '@fleet/environment';
import { FLEET_VERSION } from '@fleet/version';
export const environment = {
  production: true,
  hmr: false,
  minTokenExpiry: 60,
  fleetProduct: 'TRAVELLER',
  envName: 'traveller-bugfix-au1',
  version: FLEET_VERSION,
  ...AU1_BUGFIX_HOSTS,
};
